import endpoints from "./endpoints";
import api from "./api";

export default {
  get(languages, erpSectionId) {
    return api.get(endpoints.attributeManager.erpAttributes.get, { params: { languages, erpSectionId } }).then((x) => Promise.resolve(x.data));
  },
  update(model) {
    return api.post(endpoints.attributeManager.erpAttributes.update, model).then((x) => Promise.resolve(x.data));
  },
  delete(items) {
    return api.post(endpoints.attributeManager.erpAttributes.delete, items).then((x) => Promise.resolve(x.data));
  },
  savedeepLTranslated: async function (model, sourceLanguage) {
    return api.post(endpoints.attributeManager.erpAttributes.deepL, model, { params: { sourceLanguage: sourceLanguage } }).then((x) => Promise.resolve(x.data));
  },
  getDetails: async function (language, attributeIds) {
    const response = await api.post(endpoints.attributeManager.erpAttributes.details, attributeIds, {
      params: { language }
    });
    return response.data;
  }
};
